import React from 'react';
import { connect } from 'react-redux';
import { updateGroup, resetGroupForm } from '../../../../actions/group';
import { forceValidation, clearAllValidationErrors } from '../../../../businessLogic/validation.js';
import { displayGlobalMessage, hideGlobalMessage } from '../../../../actions/globalMessage';
import { hideModal } from '../../../../actions/modal.js';

@connect()
export default class RightPanelUpdate extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      groupForm: props.groupForm,
    };
  }
  UNSAFE_componentWillReceiveProps = (props) => {
    //THIS EVENT TRIGGERS WHEN THE PARENT UPDATES DATA

    this.setState({ groupForm: props.groupForm });
  };
  updateGroup = (e) => {
    let areThereErrors = forceValidation(undefined, undefined, 'updateGroupForm');
    if (!areThereErrors && !window.$(e.target).hasClass('disable')) {
      let cb = () => {
        this.props.dispatch(hideModal('.update-group.modal'));
        setTimeout(() => {
          this.resetForm();
        }, 500); //timeout waiting for the hide effect to finish
      };
      this.props.dispatch(updateGroup(this.state.groupForm, cb));
    }
  };

  cancelUpdateGroup = () => {
    if (window.$('.global-message.color-bad-things-bg:visible').length > 0) this.props.dispatch(hideGlobalMessage());

    this.props.dispatch(hideModal('.update-group.modal'));
    setTimeout(() => {
      this.resetForm();
    }, 200); //timeout waiting for the hide effect to finish
  };

  componentDidMount = () => {
    this.resetForm();
  };

  resetForm = () => {
    this.props.dispatch(resetGroupForm());
  };

  render() {
    let saveClasses =
      'ui disable labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull';
    return (
      <div className="ui actions mrbl max-width">
        <button
          tabIndex="8"
          type="button"
          onClick={this.updateGroup}
          data-group="updateGroupForm"
          className={this.state.groupForm.saving ? saveClasses + ' loading' : saveClasses}
        >
          {APP.LANGUAGE.Save}
          <i className="save  icon" />
        </button>
        <button
          tabIndex="9"
          type="button"
          onClick={this.cancelUpdateGroup}
          className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
    );
  }
}
